module.exports = __webpack_public_path__ + "assets/img/01.kibana-accesslog.956f14fd.png";